export const env = {
  // Direct Pages deployments do not inject local Vite environment files.
  // Keep the public V3 Worker URL as the production-safe fallback; localhost
  // is only selected when explicitly supplied by a local developer.
  apiUrl: import.meta.env.VITE_API_URL ?? 'https://verena-livetask-api.nathanon-t.workers.dev',
  appName: import.meta.env.VITE_APP_NAME ?? 'Verena LiveTask',
  appEnv: import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE,
  build: __APP_BUILD__,
  buildId: __APP_BUILD_ID__,
} as const;
